import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FloatingInput from "../common/FloatingInput";
import {
  censusBillingRules,
  getCensusPayors,
  censusGroupPlanAction,
  censusServiceConfigs,
} from "../services/soar";
import NewClientCensusRuleModal from "./NewClientCensusRuleModal";

function ClientCensusRules(props) {
  const [rules, setRules] = useState([]);
  const [setupData, setSetupData] = useState([]);
  const [status, setStatus] = useState("incomplete");
  const [filters, setFilters] = useState({ search: "" });
  const [selectedState, setSelectedState] = useState("");
  const [client, setClient] = useState("");
  const [addModalOpen, setAddModalOpen] = useState(false);
  const applicationId =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
      : "58990f83-8566-4ba8-b4b5-584a64e4cba1";
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const navigate = useNavigate();

  useEffect(() => {
    getSetupData();
    getRules();
  }, []);

  const getSetupData = async () => {
    const payorResponse = await getCensusPayors();
    const groupPlansResponse = await censusGroupPlanAction({
      command: "query",
      keyword: "viewall",
      application: applicationId,
    });
    const serviceConfigResponse = await censusServiceConfigs({
      command: "query",
      application: applicationId,
      keyword: "viewall",
    });
    setSetupData({
      ...setupData,
      payors: payorResponse
        .filter((payor) => payor.active)
        .map((payor) => ({
          _id: payor.id,
          name: payor.name,
        }))
        .sort((a, b) => a.name.localeCompare(b.name)),
      groupPlans: groupPlansResponse.data
        .filter((groupPlan) => groupPlan.active)
        .map((groupPlan) => ({
          _id: groupPlan.id,
          name: groupPlan.name,
          payorId: groupPlan.payorId,
        }))
        .sort((a, b) => a.name.localeCompare(b.name)),
      serviceConfigurations: serviceConfigResponse.data
        .filter((serviceConfig) => serviceConfig.active)
        .map((serviceConfig) => ({
          _id: serviceConfig.id,
          name: serviceConfig.name,
          config: serviceConfig.configuration,
        }))
        .sort((a, b) => a.name.localeCompare(b.name)),
    });
  };

  const getRules = async () => {
    // console.log("Setup Data", setupData);
    const response = await censusBillingRules({
      command: "query",
      application: applicationId,
      keyword: "rulesforclients",
    });
    if (response.code === "success") {
      setRules(
        response.data.sort((a, b) => a.clientName.localeCompare(b.clientName))
      );
    } else {
      toast.error(`Error loading Census Rules: ${response.message}`);
    }
  };

  return (
    <div className="container-fluid px-0">
      <div className="h4 mb-4">Client Specific Rules</div>
      <div className="row mb-4">
        <div className="col-md-6 mb-3 mb-md-0">
          <div className="row">
            <div className="col-10">
              <FloatingInput
                type="text"
                name="Search"
                label="Search"
                placeholder="Search"
                onChange={(e) => {
                  setFilters({ ...filters, search: e.target.value });
                }}
                value={filters?.search}
              />
            </div>
            <div className="col-2 d-flex align-items-center justify-content-center">
              <i
                className="fas fa-times-circle fa-xl text-danger"
                onClick={() => setFilters({ ...filters, search: "" })}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 d-flex justify-content-md-end align-items-center">
          <div
            className="btn btn-primary"
            onClick={() => setAddModalOpen("true")}
          >
            Add Client Rule
          </div>
        </div>
      </div>
      <NewClientCensusRuleModal
        isOpen={addModalOpen}
        setIsOpen={() => setAddModalOpen(false)}
      />

      <div className="row fw-bold mb-3 d-none d-md-flex">
        <div className="col-md">Client</div>
        <div className="col-md">Payor</div>
        <div className="col-md">Group Plan</div>
        <div className="col-md">Service Configuration</div>
        <div className="col-md">Actions</div>
      </div>
      {rules.map((rule) => (
        <div
          className="row rounded border border-dark bg-light p-2 mb-3"
          key={rule.id}
        >
          <div className="col-12 col-md mb-2 mb-md-0">
            <span className="fw-bold d-md-none">Client: </span>
            {rule.clientName}
          </div>
          <div className="col-12 col-md mb-2 mb-md-0">
            <span className="fw-bold d-md-none">Payor: </span>
            {rule.payorName}
          </div>
          <div className="col-12 col-md mb-2 mb-md-0">
            <span className="fw-bold d-md-none">Group Plan: </span>
            {rule.groupPlanName}
          </div>
          <div className="col-12 col-md mb-2 mb-md-0">
            <span className="fw-bold d-md-none">Service Configuration: </span>
            {rule.serviceConfigurationName}
          </div>
          <div className="col-12 col-md text-center text-md-end">
            <i
              className="fas fa-pencil text-primary mx-2 mx-md-1"
              role="button"
              onClick={() => navigate(`/rev/rules/${rule.id}`)}
            ></i>
            <i
              className={`fas fa-${
                rule.active ? "trash" : "trash-arrow-up"
              } text-${rule.active ? "danger" : "success"} mx-2 mx-md-1`}
              role="button"
              onClick={() =>
                // ruleAction(rule.id, rule.active ? "deactivate" : "reactivate")
                {}
              }
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default ClientCensusRules;
